import { Get, Set } from "../../../../../../../Request";
import { useState } from "react";
export const useCreateTimeTable = () => {
  const [loading, setLoading] = useState({
    create: false,
    send: false,
  });
  const [data, setData] = useState({});
  const [template, setTemplate] = useState(false);
  const getTemplate = async input => {
    setLoading({ ...loading, create: true });
    Get({
      url: "/item/create_step",
      data: input,
    }).then(res => {
      setTemplate(res);
      setLoading({ ...loading, create: false });
    });
  };
  const sendNewData = async data => {
    setLoading({ ...loading, send: true });
    Set({
      url: "/item/update_timetable",
      data: data,
    }).then(() => {
      setLoading({ ...loading, send: false });
    });
  };

  return {
    data,
    loading,
    setTemplate,
    template,
    setData,
    getTemplate,
    sendNewData,
  };
};
